import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

const Superadmin = () => {
  const Navigate = useNavigate()
  const Sidebar = [
    {
      id:1,
      title:'Bike',
      navigate:'/bike'
    },
    {
      id:2,
      title:'Service',
      navigate:'/service'
    }
  ]
  const SidebarHandler = (value)=>{
    Navigate(`/superadmin${value}`)
  }
  return (
    <div className='w-full h-full flex'>
      <div className='w-[250px]  border-r-2 border-r-[var(--tertiary)] h-full'>
        <div className="logo flex items-center justify-center !py-6">
        <img src="https://justbuycycles.com/cdn/shop/files/Logo-01-short.png?v=1640717324&width=500" alt="Logo" className='w-[150px]'  />
        </div>
      <ul className="">
        {Sidebar?.map((item,index)=>{
          return <li key={item.id}
          className="bg-[var(--secondary)] text-[var(--dark)] font-[500]  cursor-pointer !py-2 !pl-2 !my-1 text-sm"
          onClick={()=>SidebarHandler(item.navigate)}
        >
          {item.title}
        </li>
        })}
        </ul>
      </div>
      <div className='w-[calc(100%-250px)]  h-full'>
        <Outlet />
      </div>
    </div>
  )
}

export default Superadmin